import { Link } from "react-router-dom";
import tableClass from "../../Table/Table.module.css";
import classes from "../../Employee/AddEmployeeDirectory/AddEmployeeDirectory.module.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useContext } from "react";
import authContext from "../../../../AuthContext/authContext";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import departments from "../../Common/departmentDropDown/Departments";

const base_url = process.env.REACT_APP_BASE_URL;

const EditGuard = ({ initialData }) => {
  const activeCompany = useSelector((state) => state.appData.activeCompany);
  const activeLocation = useSelector((state) => state.appData.activeLocation);
  const ctx = useContext(authContext);
  console.log(activeLocation,"activeLocation");
  const userType = ctx.userData.user_type;
  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
  const nameRegExp = /^[A-Za-z ]+$/;
  const departmentRegExp = /^[A-Za-z-& ]+$/;
  const formik = useFormik({
    enableReinitialize: initialData,
    initialValues: {
      name: initialData.name,
      email: initialData.email,
      phone: initialData.phone,
      locationId: activeLocation._id,
      location: activeLocation.location
    },
    validationSchema: Yup.object({
      name: Yup.string()
        // .matches(nameRegExp, "Please enter valid name")
        .required("Please enter employee name"),
      email: Yup.string()
        .email("Invalid email address")
        .required("Please enter email address"),
      phone: Yup.string()
        .matches(phoneRegExp, "Phone number is not valid")
        .length(10, "Phone number should be of 10 digits")
        .required("Please enter your phone number")
    }),
    onSubmit: async (values) => {
      if (!activeLocation._id || activeLocation.location === "All") {
        toast.error("Please select a location");
        return;
      }
   console.log({
    name: values.name,
    email: values.email,
    phone: values.phone,
    location: activeLocation.location,
    companyId: activeCompany._id,
    locationId: activeLocation._id,
    userId: initialData.user_id
  },"values");
      let reqObj = {
        method: "PUT",
        url: `${base_url}/user/profile`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${ctx.token}`
        },
        data: {
          name: values.name,
          email: values.email,
          phone: values.phone,
          location: activeLocation.location,
          userId: initialData._id
        }
      };

      axios(reqObj)
        .then((res) => {
          toast.dismiss();
          toast.success("Employee data updated successfully");
        })
        .catch((err) => {
          console.log(err);
          toast.dismiss();
          toast.error(
            err.response.data.error.message || "Failed to update employee data"
          );
        });
    }
  });

  const showIcons = userType !== "Building Manager";
  const showLocation = activeCompany.type === "Company";
  const showEmployeeDirectory = activeCompany.type === "Company";

  return (
    <>
      <div className={classes.mainCont}>
        <h3>Edit Guard {initialData.location}</h3>
        <div className={classes.topLinks}>
        </div>

        <form className={classes.FormDiv} onSubmit={formik.handleSubmit}>
          <div className={classes.formGrp}>
            <label for="name">Guard Name:</label>

            <div>
              <input
                type="text"
                id="name"
                name="name"
                {...formik.getFieldProps("name")}
              />
              <span className={classes.profileerrMsg}>
                {formik.touched.name && formik.errors.name ? (
                  <div>{formik.errors.name}</div>
                ) : null}
              </span>
            </div>
          </div>

          <div className={classes.formGrp}>
            <label for="email">Guard Email:</label>
            <div>
              <input
                type="text"
                id="email"
                name="email"
                {...formik.getFieldProps("email")}
              />
              <span className={classes.profileerrMsg}>
                {formik.touched.email && formik.errors.email ? (
                  <div>{formik.errors.email}</div>
                ) : null}
              </span>
            </div>
          </div>

          <div className={classes.formGrp}>
            <label for="phone">Guard Phone: </label>
            <div>
              <input
                type="text"
                id="phone"
                name="phone"
                {...formik.getFieldProps("phone")}
              />
              <span className={classes.profileerrMsg}>
                {formik.touched.phone && formik.errors.phone ? (
                  <div>{formik.errors.phone}</div>
                ) : null}
              </span>
            </div>
          </div>

          <div className={classes.formBtn}>
            {/* <button type="button" className={classes.cancleBtn}>
              Cancle
            </button> */}
            <button type="submit" className={classes.createBtn}>
              Update
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default EditGuard;
